// extracted by mini-css-extract-plugin
export default {"facePileMore":"ValueFacePile_facePileMore__aIGz0","wrapper":"ValueFacePile_wrapper__npO4r"};